import { render, staticRenderFns } from "./MissingPermissionList.vue?vue&type=template&id=650f83b3&scoped=true&"
import script from "./MissingPermissionList.vue?vue&type=script&lang=js&"
export * from "./MissingPermissionList.vue?vue&type=script&lang=js&"
import style0 from "./MissingPermissionList.vue?vue&type=style&index=0&id=650f83b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650f83b3",
  null
  
)

export default component.exports